import { CdkDragDrop, CdkDragEnd } from '@angular/cdk/drag-drop';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SignPdfService } from '../../sign-pdf.service';

@Component({
  selector: 'app-side-nav-content',
  templateUrl: './side-nav-content.component.html',
  styleUrls: ['./side-nav-content.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SideNavContentComponent implements OnInit {
  peopleInvitationData = this.signPdfService.getPeopleInvitationData();
 
  actionList = [
    { name: 'Signature', icon: ['fas', 'signature'], color: "red" }
  ];
  formData: any = [];
  done:any = [];
  offsetLeft = 0;//284
  offsetTop = 0;
  aditionalSpace: number = 100;
  scrollOffsetLeft: number = 0;
  scrollOffsetTop: number = 0;
  dropedItemLeftOffset: any;
  dropedItemTopOffset: any;
  selectedUser: any = 1;
  
  constructor(private signPdfService: SignPdfService,private router: Router) { }

  ngOnInit(): void {

    // let formData = localStorage.getItem("formData");
    // this.formData = formData ? JSON.parse(formData) : '';

    this.peopleInvitationData.subscribe(res => {
     
        this.formData = res;
        console.log("peopleInvitationData", res)
      

    })

      

  }

  changed(e:any){
    this.selectedUser = e.target.value;
    this.signPdfService.setSelectedUserData(this.selectedUser);
  }


  onNavigationSelection(navItem: any) {
    this.router.navigate([navItem.route]);
  }

  getPageOffsetWidth() {//
    let pageTag:any = document.getElementsByClassName('page')[0];
    this.offsetLeft = pageTag ? pageTag['offsetLeft'] : 0;
    this.offsetTop = pageTag ? pageTag['offsetTop'] : 0;
    //padding adding 40px in css so
    this.offsetTop = this.offsetTop + this.aditionalSpace;
    console.log("offsetLeft",this.offsetLeft)
    this.getPageScrollOffsetWidth();
    
  }
  getPageScrollOffsetWidth() {//
    
    this.scrollOffsetLeft = this.getScrollLeftOfPage();

    this.scrollOffsetTop = this.getScrollTopOfPage();
 
  }

getScrollLeftOfPage(){
    return (document.getElementsByClassName('ng2-pdf-viewer-container')[0] ? document.getElementsByClassName('ng2-pdf-viewer-container')[0]['scrollLeft']  : 0) + ( window.scrollX ? window.scrollX : 0);
  }
  getScrollTopOfPage(){
    return (document.getElementsByClassName('ng2-pdf-viewer-container')[0] ? document.getElementsByClassName('ng2-pdf-viewer-container')[0]['scrollTop']  : 0) + ( window.scrollY ? window.scrollY : 0);
  }

  drop(event: any) {
    this.getPageOffsetWidth();
    
    if (event.previousContainer === event.container) {
      
    } else {

      let item = JSON.parse(JSON.stringify(event.previousContainer.data[event.previousIndex]));

      let currentItemTop = this.getOffset(document.getElementById("todoItem"+event.previousIndex)).top + this.dropedItemTopOffset;

      // console.log("todoItem",this.getOffset(document.getElementById("todoItem"+event.previousIndex)).top ,'test', currentItemTop);

      // item['color'] = this.selectedUser ? `${this.formData.PeopleInvites[this.selectedUser - 1].color}` : `${this.formData?.PeopleInvites[0].color}`;

      // item['page'] = this.page;
      // item['userAssigned'] = this.selectedUser ? `${this.formData.PeopleInvites[this.selectedUser - 1].Email}` : `${this.formData?.PeopleInvites[0].Email}`;
      // item['isSigned'] = false;

      item['coordinates'] = {
        left: this.dropedItemLeftOffset ,
        top: currentItemTop  
      }
      this.done = [item, ...this.done];
    }
    
  }

  getWidthOfDiv(el:any) {
    return el.offsetWidth;
  }

  // dragEnd
  dragEnd($event: any) {
    console.log("usmannn dragEnd")
    let width = this.getWidthOfDiv(document.getElementById('section-1'));

    this.getPageOffsetWidth();

    this.dropedItemLeftOffset = (width + $event.distance.x) -  this.offsetLeft ;
    this.dropedItemTopOffset = $event.distance.y ; 
}



getOffset(el:any) {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  };
}






}




